import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type RegisterPushRequest = {
  token: string;
  platform?: string;
};

export type RegisterPushParams = RequestConfig<RegisterPushRequest>;

export const registerPush = async ({ params, config }: RegisterPushParams) =>
  api.post('/api/push/register', params, config);
